import api from '../api';
import { RealtimeInsightsRequest, ESPItem } from '../../features/well-summary/RealtimeInsightsSlice';

class RealtimeInsightsService {
  // ESP endpoint
  async getESPData(request: RealtimeInsightsRequest): Promise<ESPItem[]> {
    try {
      const response = await api.post('/WellDashboardDetails/ESP', request);
      return response.data.data;
    } catch (error) {
      console.error('ESP API call failed:', error);
      throw new Error(`ESP API call failed: ${error}`);
    }
  }

  // Gas Lift endpoint
  async getGasLiftData(request: RealtimeInsightsRequest): Promise<ESPItem[]> {
    try {
      const response = await api.post('/WellDashboardDetails/GasLift', request);
      return response.data.data;
    } catch (error) {
      console.error('Gas Lift API call failed:', error);
      throw new Error(`Gas Lift API call failed: ${error}`);
    }
  }

  // Rod Lift endpoint
  async getRodLiftData(request: RealtimeInsightsRequest): Promise<ESPItem[]> {
    try {
      const response = await api.post('/WellDashboardDetails/RodLift', request);
      return response.data.data;
    } catch (error) {
      console.error('Rod Lift API call failed:', error);
      throw new Error(`Rod Lift API call failed: ${error}`);
    }
  }
}

export const realtimeInsightsService = new RealtimeInsightsService();
